var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMensajeriaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7647 0H3.6814C1.95548 0 0.556396 1.39909 0.556396 3.125V21.875C0.556396 23.6009 1.95548 25 3.6814 25H30.7647C32.4906 25 33.8897 23.6009 33.8897 21.875V3.125C33.8897 1.39909 32.4906 0 30.7647 0ZM30.7647 3.125V5.78157C29.305 6.97031 26.9777 8.81875 22.0026 12.7145C20.9061 13.577 18.7343 15.6489 17.2231 15.6247C15.7121 15.6492 13.5395 13.5766 12.4436 12.7145C7.46916 8.81934 5.14136 6.97051 3.6814 5.78157V3.125H30.7647ZM3.6814 21.875V9.79154C5.17319 10.9798 7.28875 12.6471 10.5133 15.1721C11.9363 16.2923 14.4283 18.765 17.2231 18.7499C20.0041 18.765 22.4645 16.3281 23.9322 15.1727C27.1567 12.6477 29.2729 10.9799 30.7647 9.7916V21.875H3.6814Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMensajeriaIcon);
export default __webpack_public_path__ + "static/media/mensajeria_icon.34f7a54dda4af2db53cbca4e79213e61.svg";
export { ForwardRef as ReactComponent };